import { z } from 'zod';

/** Messages are i18n keys, translated where the error is shown. */
export const emailField = z
  .string()
  .trim()
  .min(1, 'validation.required')
  .max(254)
  .pipe(z.email('validation.email'));
/** NIST SP 800-63B, as smoke-backend: length over composition rules. */
export const passwordField = z
  .string()
  .min(12, 'validation.passwordMin')
  .max(256, 'validation.passwordMax');

export const loginSchema = z.object({
  email: emailField,
  password: z.string().min(1, 'validation.required').max(256),
});

export const signUpSchema = z.object({
  displayName: z.string().trim().max(100).optional(),
  email: emailField,
  password: passwordField,
});

export const resetSchema = z
  .object({ password: passwordField, confirm: z.string() })
  .refine((v) => v.password === v.confirm, {
    message: 'validation.passwordMismatch',
    path: ['confirm'],
  });
